































import ProfilesAssociationByProductCompaniesTable, {
  CompanySelectEvent,
} from "@/components/Agents/ProfilesAssociationByProduct/CompaniesTable.vue";
import ProfilesAssociationByProductProductsTable, {
  ProductSelectEvent,
} from "@/components/Agents/ProfilesAssociationByProduct/ProductsTable.vue";
import ClientCompanySearch from "@/components/ClientCompanySearch.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";
import EntryItem from "@/components/EntryItem.vue";
import { EntrySearchResult } from "@/components/EntrySearch.vue";
import ProfileAssociationMixin, {
  PofileAssociationMixinTags,
  MatchCompaniesPayload,
  MatchProductsPayload,
} from "@/mixins/http/Agents/MatchByProduct/ProfileAssociationMixin";
import { AdcontrolProfile } from "@/models";
import ProfileAssociation from "@/models/Agents/ProfileAssociation";
import { showToast } from "@/utils/ToastInvoker";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

export type ProfilesAssociationTableMatchType = "companies" | "products";

@Component({
  components: {
    ConfirmModal,
    ClientCompanySearch,
    EntryItem,
    ProfilesAssociationByProductCompaniesTable,
    ProfilesAssociationByProductProductsTable,
  },
})
export default class ProfilesAssociationByProduct extends Mixins(
  ProfileAssociationMixin
) {
  @Prop({ default: "companies" })
  readonly matchType!: ProfilesAssociationTableMatchType;

  @Getter("profile") profile!: AdcontrolProfile;

  profileAssociations: ProfileAssociation[] = [];
  entries: EntrySearchResult = {
    companies: [],
    brands: [],
    products: [],
    total: 0,
  };

  companiesPayload: MatchCompaniesPayload[] = [];
  productsPayload: MatchProductsPayload[] = [];

  mounted() {
    this.load();
  }

  @Watch("matchType")
  onMatchTypeChanged() {
    this.load();
  }

  get profileSlug(): string {
    return this.profile.slug.toUpperCase();
  }

  get distinctCompaniesLoading(): boolean {
    return (
      this.$store.getters["http/status"][
        PofileAssociationMixinTags.GetDistinctCompanies
      ]?.loading ?? false
    );
  }

  get associationsByProductLoading(): boolean {
    return (
      this.$store.getters["http/status"][
        PofileAssociationMixinTags.GetAssociationsByProducts
      ]?.loading ?? false
    );
  }

  get matchCompaniesLoading(): boolean {
    return (
      this.$store.getters["http/status"][
        PofileAssociationMixinTags.MatchCompanies
      ]?.loading ?? false
    );
  }

  get ignoreCompanyLoading(): boolean {
    return (
      this.$store.getters["http/status"][
        PofileAssociationMixinTags.IgnoreCompany
      ]?.loading ?? false
    );
  }

  get loading(): boolean {
    return (
      this.distinctCompaniesLoading ||
      this.matchCompaniesLoading ||
      this.ignoreCompanyLoading ||
      this.associationsByProductLoading
    );
  }

  get ignoreConfirmModalTitle(): string {
    switch (this.matchType) {
      case "companies":
        return "Ignora azienda";
      case "products":
        return "Ignora prodotto";
      default:
        return "";
    }
  }

  async load() {
    switch (this.matchType) {
      case "companies":
        await this.loadCompanies();
        break;
      case "products":
        await this.loadProducts();
        break;
    }
  }

  async loadCompanies() {
    this.profileAssociations = [];
    const profileAssociations = await this.getDistinctCompanies(
      this.profile.slug
    );
    this.profileAssociations = [...profileAssociations];
  }

  async loadProducts() {
    this.profileAssociations = [];
    const profileAssociations = await this.getAssociationsByProducts(
      this.profile.slug
    );
    this.profileAssociations = [...profileAssociations];
  }

  get shownProfileAssociations() {
    return this.profileAssociations.filter((p) => !p.ignored);
  }

  async onMatchCompanies() {
    try {
      await this.matchCompanies(this.profile.slug, this.companiesPayload);
      this.companiesPayload = [];
      showToast("Associazioni per aziende salvate");
      await this.loadCompanies();
    } catch (exception) {
      showToast("Errore durante il salvataggio", { type: "error" });
    }
  }

  async onMatchProducts() {
    try {
      await this.matchProducts(this.profile.slug, this.productsPayload);
      this.productsPayload = [];
      showToast("Associazioni per prodotti salvate");
      await this.loadProducts();
    } catch (exception) {
      showToast("Errore durante il salvataggio", { type: "error" });
    }
  }

  onCompanySelected(event: CompanySelectEvent) {
    const payload = [...this.companiesPayload];

    const index = payload.findIndex(
      (p) => p.companyId == event.profileAssociation.company.id
    );
    if (index >= 0) {
      payload[index] = {
        companyId: event.profileAssociation.company.id,
        clientCompanyPrincipalId: event.company.id,
      };
    } else {
      payload.push({
        companyId: event.profileAssociation.company.id,
        clientCompanyPrincipalId: event.company.id,
      });
    }

    this.companiesPayload = [...payload];
  }

  onProductSelected(event: ProductSelectEvent) {
    const payload = [...this.productsPayload];

    const index = payload.findIndex(
      (p) => p.associationId == event.profileAssociation.id
    );
    if (index >= 0) {
      payload[index] = {
        associationId: event.profileAssociation.id,
        productPrincipalId: event.product.id,
      };
    } else {
      payload.push({
        associationId: event.profileAssociation.id,
        productPrincipalId: event.product.id,
      });
    }

    this.productsPayload = [...payload];
  }

  onCompanySearch(association: ProfileAssociation) {
    const payload = [...this.companiesPayload];

    const index = payload.findIndex(
      (p) => p.companyId === association.company.id
    );
    if (index >= 0) {
      payload.splice(index, 1);
    }

    this.companiesPayload = [...payload];
  }

  onProductSearch(association: ProfileAssociation) {
    const payload = [...this.productsPayload];

    const index = payload.findIndex((p) => p.associationId === association.id);
    if (index >= 0) {
      payload.splice(index, 1);
    }

    this.productsPayload = [...payload];
  }

  async onIgnoreCompany(association: ProfileAssociation) {
    const confirmed = await (
      this.$refs.ignoreConfirmModal as ConfirmModal
    ).confirm(
      `Sei sicuro di voler ignorare questa associazione? Non sarà più possibile associare questa azienda con l'anagrafica ${this.profileSlug}.`
    );

    if (!confirmed) {
      return;
    }

    try {
      await this.ignoreCompany(this.profile.slug, association.company.id);
      showToast("Azienda ignorata");
    } catch (exception) {
      showToast("Errore durante il salvataggio", { type: "error" });
    } finally {
      this.loadCompanies();
    }
  }

  async onIgnoreProduct(association: ProfileAssociation) {
    const confirmed = await (
      this.$refs.ignoreConfirmModal as ConfirmModal
    ).confirm(
      `Sei sicuro di voler ignorare questa associazione? Non sarà più possibile associare questo prodotto con l'anagrafica ${this.profileSlug}.`
    );

    if (!confirmed) {
      return;
    }

    try {
      await this.ignoreProduct(this.profile.slug, association.id);
      showToast("Prodotto ignorato");
    } catch (exception) {
      showToast("Errore durante il salvataggio", { type: "error" });
    } finally {
      this.loadProducts();
    }
  }
}
